import React from 'react';
import './MenuItem.css';
import Icon, { IconName } from '../icons/Icon';

interface MenuItemProps {
  type?: 'Default' | 'Destructive';
  state?: 'Default' | 'Hover' | 'Pressed' | 'Disabled';
  label?: string;
  leftIcon?: IconName;
  rightIcon?: IconName;
  showLeftIcon?: boolean;
  showRightIcon?: boolean;
  onClick?: () => void;
  className?: string;
}

const MenuItem: React.FC<MenuItemProps> = ({
  type = 'Default',
  state = 'Default',
  label = 'メニューテキスト',
  leftIcon,
  rightIcon,
  showLeftIcon = false,
  showRightIcon = false,
  onClick,
  className = ''
}) => {
  const getTextColor = () => {
    if (type === 'Destructive') {
      return state === 'Disabled' ? '#a1acb8' : '#ea3b47';
    }
    return state === 'Disabled' ? '#a1acb8' : '#373e45';
  };

  const getBackgroundColor = () => {
    if (state === 'Disabled') return 'transparent';
    if (state === 'Hover') return 'rgba(37,41,47,0.06)';
    if (state === 'Pressed') return 'rgba(37,41,47,0.08)';
    return 'transparent';
  };

  const getIconColor = () => {
    if (state === 'Disabled') return '#a1acb8';
    if (type === 'Destructive') return '#ea3b47';
    return '#373e45';
  };

  const handleClick = () => {
    if (state !== 'Disabled' && onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`menu-item 
        ${type === 'Destructive' ? 'menu-item--destructive' : ''} 
        ${state === 'Disabled' ? 'menu-item--disabled' : ''} 
        ${className}
      `}
      onClick={handleClick}
    >
      <div className="menu-item__state-layer">
        {showLeftIcon && leftIcon && (
          <Icon
            name={leftIcon}
            size={24}
            className='leftIcon'
          />
        )}
        <span className="menu-item__label">{label}</span>
        {showRightIcon && rightIcon && (
          <Icon
            name={rightIcon}
            size={24}
            className='rightIcon'
          />
        )}
      </div>
    </div>
  );
};

export default MenuItem;